package component.product

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Color.Companion.White
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import appConfig.AppConfig
import com.friendly.shared.component.button.StepperButton
import component.image.ImageView
import feature.cart.handler.CartHandler
import feature.cart.viewModel.CartViewModel
import feature.product.model.Product
import theme.ThemeColor

@Composable
fun ProductCard(product: Product, onClick: (Product) -> Unit) {
    val cartViewModel = CartViewModel(CartHandler.shared().repository)
//    val cart: State<JsonObject?> = cartViewModel.cart.observeAsState()
    var count by remember { mutableIntStateOf(0) }
//    if (cart.value != null) {
//        count = cartViewModel.getProductQuantity(product)
//    }
    Column(
        modifier = Modifier
            .height(330.dp)
            .width(180.dp)
            .padding(start = 8.dp, end = 8.dp)
            .shadow(3.dp)
            .background(ThemeColor.shared().White)
            .zIndex(1f)
            .clickable { onClick(product) }
    ) {
        Box(
            modifier = Modifier
                .height(165.dp)
                .fillMaxWidth()
                .background(Color.LightGray, shape = RoundedCornerShape(10.dp))
                .clip(RoundedCornerShape(10.dp))
                .clickable { onClick(product) },
            contentAlignment = Alignment.Center
        ) {
            ImageView(id = product.Id)
        }
        Text(
            text = product.Name ?: "",
            maxLines = 4,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier
                .width(160.dp)
                .height(120.dp)
                .padding(8.dp)
        )
        if (count > 0) {
            Row(
                modifier = Modifier
                    .padding(8.dp)
                    .width(160.dp)
                    .height(70.dp)
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(
                    modifier = Modifier.padding(end = 20.dp),
                    text = "${AppConfig.shared().currencySymbol} ${product.ProductPrice.FinalPrice}",
                    fontWeight = FontWeight(600),
                    color = ThemeColor.shared().TextColor
                )
                StepperButton(
                    count = count,
                    onDecrease = {
                        count -= 1
//                        cartViewModel.removeFromCart(product)
                    },
                    onIncrease = {
                        count += 1
//                        cartViewModel.addToCart(product)
                    }
                )
            }
        } else {
            Row(
                modifier = Modifier
                    .padding(8.dp)
                    .width(140.dp)
                    .height(50.dp)
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(
                    text = "${AppConfig.shared().currencySymbol} ${product.ProductPrice.FinalPrice}",
                    fontWeight = FontWeight(600),
                    color = ThemeColor.shared().PrimaryColor
                )
                Box(
                    modifier = Modifier
                        .height(30.dp)
                        .width(20.dp)
                ) {
                    IconButton(
                        onClick = {
                            count += 1
//                            cartViewModel.addToCart(product)
                        },
                        modifier = Modifier
                            .size(30.dp)
                            .border(1.dp, White, shape = CircleShape)
                    ) {
                        Icon(
                            Icons.Default.Add,
                            contentDescription = "increase quantity",
                            tint = ThemeColor.shared().PrimaryColor
                        )
                    }
                }
            }
        }
    }
}